.left-content {
    display: flex;
    flex-direction: column;
    min-width: 400px;
    gap: 32px;
}
